import SelectionImage from './SelectionImage';

export default SelectionImage;
